"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvironmentConfig = exports.ENVIRONMENT_CONFIGS = void 0;
const environments_enum_1 = require("../model/environments.enum");
exports.ENVIRONMENT_CONFIGS = {
    [environments_enum_1.Environments.LOCALHOST]: {
        rpcUrl: 'http://127.0.0.1:9545/',
        contractAddresses: {
            ensRegistry: process.env.DOCKER_ENS_REGISTRY_ADDRESS,
            fdsRegistrar: process.env.DOCKER_FDS_REGISTRAR_ADDRESS,
            publicResolver: process.env.DOCKER_PUBLIC_RESOLVER_ADDRESS,
        },
        performChecks: false,
    },
    [environments_enum_1.Environments.GOERLI]: {
        rpcUrl: 'https://xdai.dev.fairdatasociety.org/',
        contractAddresses: {
            ensRegistry: process.env.GOERLI_ENS_REGISTRY_ADDRESS,
            fdsRegistrar: process.env.GOERLI_FDS_REGISTRAR_ADDRESS,
            publicResolver: process.env.GOERLI_PUBLIC_RESOLVER_ADDRESS,
        },
        performChecks: false,
    },
};
function getEnvironmentConfig(environment) {
    return exports.ENVIRONMENT_CONFIGS[environment];
}
exports.getEnvironmentConfig = getEnvironmentConfig;
